import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  formHelperText: {
    marginTop: 0,
    fontSize: 12,
    whiteSpace: 'nowrap',
    color: theme.palette.text.primary,
  },
}));
